import React, { useState, useEffect } from 'react'
import { brainzBalance, stake } from '../../../Contract/Web3Client'
import {
  StakingContainer,
  Heading,
  Subtitle,
  FormContainer,
  StakingForm,
  Label,
  StakingSubmit,
  TextField,
  BrainzInput,
  TextFieldError
} from './StakingElements'


const Staking = ({address}) => {
  const [brainz, setBrainz] = useState(0)
  const [count, setCount] = useState(0)
  const [error, setError] = useState("")

  useEffect(async () => {
    setBrainz(await brainzBalance(address))
}, [address])

  useEffect(() => {
    if (count > brainz) {
        setError("Can't Use More Brainz Than You Own");
    }
    else if (error === "Can't Use More Brainz Than You Own") {
        setError("");
    }
  })

  const submitForm = () => {
    stake(count, address)
  }

  return (
    <>
      <StakingContainer>
        <Heading>Old School Runescape Staking</Heading>
        <Subtitle>Staking in the Duel Arena in Old School Runescape gives a 50% chance to double or to lose your wager.
          We've implemented something similar with $BRAINZ. You have a 50% chance to win 1.9x your wager, or 50% chance to lose it all. Good Luck
        </Subtitle>
        <TextField>$BRAINZ: {brainz}</TextField>
        <FormContainer>
         <StakingForm
            onSubmit={e => {
              e.preventDefault()
              submitForm()
            }}>
            <Label>
              Input $BRAINZ Wager:
              <BrainzInput placeholder="2,147,483,647 $BRAINZ" onChange={e => setCount(parseInt(e.target.value, 10))}/>
            </Label>
            <TextFieldError>{error}</TextFieldError>
            <StakingSubmit disabled={error.length > 0} type="submit" value="Stake $BRAINZ" />
            <Subtitle>NOTE: You will need to refresh to update your $BRAINZ balance for now
        </Subtitle>
          </StakingForm>
        </FormContainer>
      </StakingContainer>
    </>
  )
}

export default Staking
